import React, { useState } from "react";
import { useLocation } from "react-router-dom";
import "../Header.css";
import { ReactComponent as DownArrow } from "../../../images/icons/dropdownArrow.svg";
import LinkWithLanguage from "../../reusable/LinkWithLanguage/LinkWithLanguage";
import TEXT from "../../../utils/text/header.json";
import { useCurrentLanguage } from "../../../hooks/useCurrentLanguage";
import { PAGE_OPTIONS } from "../../../utils/constants/pageOptions";

export default function HeaderDropdown() {
  const location = useLocation();
  const { language } = useCurrentLanguage();

  const [isOpen, setIsOpen] = useState(false);

  function getCurrentPageLabel() {
    const currentPage =
      location.pathname === "/"
        ? PAGE_OPTIONS.find((o) => o.url === "/")
        : PAGE_OPTIONS.filter((o) => o.url !== "/").find((o) =>
            location.pathname.includes(o.url)
          );

    return currentPage ? currentPage.code : "homepage";
  }

  return location.pathname === "/login" ? null : (
    <div className="header-container">
      <button onClick={() => setIsOpen(!isOpen)} className="header-button">
        <div className="header-main">
          <div className="header-font-size header-bold">
            {TEXT[getCurrentPageLabel()][language]}
          </div>
          <div className="arrow">
            {isOpen ? <DownArrow className="rotate" /> : <DownArrow />}
          </div>
        </div>
      </button>

      <div className="header-options">
        {isOpen ? (
          <>
            {PAGE_OPTIONS.map((option, i) => {
              return (
                <LinkWithLanguage
                  to={option.url}
                  className="option-button"
                  content={
                    <button
                      onClick={() => setIsOpen(false)}
                      className={
                        "header-text-option header-font-size header-button bold" +
                        (location.pathname === option.url ||
                        (location.pathname.includes("/conversacion") &&
                          option.url === "/conversacion")
                          ? " header-bold"
                          : null)
                      }
                    >
                      {TEXT[option.code][language]}
                    </button>
                  }
                  key={i}
                />
              );
            })}
          </>
        ) : null}
      </div>
    </div>
  );
}
